// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface DrawerIconSignature {
  Element: SVGSVGElement;
}

export const DrawerIcon: TOC<DrawerIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19 6.00098H5V8.00098H19V6.00098ZM5 11H19V14H5V11ZM5 16H19V19H5V16Z"/>
</svg>
</template>;